<template>
  <div :class="$style.ctn">
    <PaginationTable
      :class="$style.table"
      :head="requestsHead"
      :values="requests"
      :pagination-detach="true"
    >
      <template #cell="{ cell, i }">
        <b v-if="i === 0">
          {{ cell }}
        </b>
        <template v-else-if="i === 3">
          <b :class="$style.interface">{{ cell.interface }}</b>
          <span>{{ cell.method }}</span>
        </template>
        <span v-else-if="i === 4" :class="$style.keyValue">
          <template v-for="(name, i) in parametersHead" :key="i">
            <b>{{ name }}</b>
            <span>{{ cell[i] }}</span>
          </template>
        </span>
      </template>
      <template #footer>
        <TipMessage :class="$style.tipMessage" :full-report-link-at-end="true">
          Find more information about RPC Requests at the
        </TipMessage>
      </template>
    </PaginationTable>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import PaginationTable from './PaginationTable.vue';
import TipMessage from './TipMessage.vue';

export default defineComponent({
  components: { PaginationTable, TipMessage, PaginationTable },
  inject: ['root'],
  data: () => ({
    requestsHead: [
      { value: 'PID', width: 58 },
      { value: 'Process', width: 170 },
      { value: 'Type', width: 44 },
      { value: 'Interface and Method', width: 270 },
      { value: 'Parameters', width: 538 },
    ],
    parametersHead: ['hService', 'KeyValue', 'InfoLevel', 'ServiceName', 'DesiredAccess'],
  }),
  computed: {
    requests() {
      return this.root.rpsRequests.values;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}
.badge {
  padding-right: 15px;
  display: inline-block;
  width: 100%;
}
* + .tipMessage {
  margin-top: 15px;
}
.tipMessage + * {
  margin-top: 20px;
}
.interface + * {
  display: block;
  margin-top: 6px;
}
.keyValue {
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-gap: 6px 16px;
  & > b {
    color: rgba(63, 71, 87, 0.87);
  }
}

.table {
  --padding-left-right: 14px;
}
</style>
